import request from '@/utils/request2'

// 列表(主数据列表)
export function loadPhysicalResourcesClaimFormListDataApi(data) {
  return request({
    url: 'tms-web/physicalResourcesClaimForm/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportPhysicalResourcesClaimFormListDataApi(data) {
  return request({
    url: 'tms-web/physicalResourcesClaimForm/exportByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewPhysicalResourcesClaimFormApi(data) {
  return request({
    url: 'tms-web/physicalResourcesClaimForm/view',
    method: 'post',
    data
  })
}
